module.exports = __webpack_public_path__ + "static/media/multipay-logo-highres.59a0daa4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/multipay-logo-highres.png
 ** module id = 316
 ** module chunks = 0
 **/